import { render, staticRenderFns } from "./releases.vue?vue&type=template&id=28a33016&scoped=true&"
import script from "./releases.vue?vue&type=script&lang=js&"
export * from "./releases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a33016",
  null
  
)

export default component.exports